import { Variants } from 'framer-motion';

export const slideTransitionVariants: Variants = {
  enter: (direction: number) => ({
    x: direction > 0 ? 500 : -500,
    opacity: 0,
    scale: 0.95
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
    scale: 1
  },
  exit: (direction: number) => ({
    zIndex: 0,
    x: direction > 0 ? -500 : 500,
    opacity: 0,
    scale: 0.95
  })
};

export const slideTransitionConfig = {
  type: "spring",
  bounce: 0,
  duration: 0.3,
  opacity: { duration: 0.2 },
  scale: { duration: 0.25 }
};

export const fadeInVariants: Variants = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0 }
};

export const fadeInConfig = {
  duration: 0.3
};

export const radioSelectionAnimation = {
  scale: [1, 1.6, 0.92, 1.15, 1],
  transition: {
    duration: 0.3,
    ease: "easeInOut",
    times: [0, 0.3, 0.5, 0.8, 1]
  }
};

export const RADIO_BUTTON_ANIMATION_DELAY = 600; // milliseconds 